import { BuildingBuilding, CondominiumCondominium, Contactcontactv2Company, InsuranceInsurance, MortgageMortgage, ObjectObject, ObjectdeviceDevice, ObjectpropertyProperty, ObjectroomRoom, ObjecttenancyTenancy, TicketTicketReference, V2Person, V2Request } from '@/types/api'

const ticketConnections = {
  methods: {
    setInsuranceId(insurance: InsuranceInsurance, middleClick: boolean = false): void {
      const source = insurance.referenceId.startsWith('building') ? 'building' : 'property'
      if (source === 'building') {
        localStorage.setItem('expandBuildingInsuranceId', insurance.id)
      } else if (source === 'property') {
        localStorage.setItem('expandPropertyInsuranceId', insurance.id)
      }
      this.redirectToParentDetail(insurance, middleClick)
    },
    setMortgageId(mortgage: MortgageMortgage, middleClick: boolean = false): void {
      const source = mortgage.referenceId.startsWith('building') ? 'building' : 'property'
      if (source === 'building') {
        localStorage.setItem('expandBuildingMortgageId', mortgage.id)
      } else if (source === 'property') {
        localStorage.setItem('expandPropertyMortgageId', mortgage.id)
      }
      this.redirectToParentDetail(mortgage, middleClick)
    },
    redirectToParentDetail(item: InsuranceInsurance | MortgageMortgage, middleClick: boolean): void {
      if (item.referenceId.startsWith('building')) {
        if (!middleClick) {
          this.$router.push(this.redirectToDetailPage(item, 'building'))
        } else {
          const route = this.$router.resolve(this.redirectToDetailPage(item, 'building'))
          window.open(route.href, '_blank')
        }
      } else if (item.referenceId.startsWith('prop')) {
        if (!middleClick) {
          this.$router.push(this.redirectToDetailPage(item, 'prop'))
        } else {
          const route = this.$router.resolve(this.redirectToDetailPage(item, 'prop'))
          window.open(route.href, '_blank')
        }
      }
    },
    getReferenceName(id: string): string {
      let name = ''
      if (id.startsWith('device')) {
        const device = this.getConnection(id)
        if (device.referenceId.startsWith('prop')) {
          this.allConnections.properties.forEach(property => {
            if (property.id === device.referenceId) {
              name = property.name
            }
          })
        } else if (device.referenceId.startsWith('building')) {
          this.allConnections.buildings.forEach(building => {
            if (building.id === device.referenceId) {
              name = building.name
            }
          })
        } else if (device.referenceId.startsWith('obj')) {
          this.allConnections.objects.forEach(object => {
            if (object.id === device.referenceId) {
              name = object.name
            }
          })
        }
      }
      if (id.startsWith('mortgage') || id.startsWith('ins')) {
        const item = this.getConnection(id)
        if (item.referenceId.startsWith('prop')) {
          this.allConnections.properties.forEach(property => {
            if (property.id === item.referenceId) {
              name = property.name
            }
          })
        } else if (item.referenceId.startsWith('building')) {
          this.allConnections.buildings.forEach(building => {
            if (building.id === item.referenceId) {
              name = building.name
            }
          })
        }
      }
      return name
    },
    findConnectionId(reference: TicketTicketReference, type: string): string {
      return reference.relatedIds.find((x: string) => x.startsWith(type))
    },
    getConnection(id: string) {
      if (id.startsWith('condominium')) {
        return this.allConnections.condominiums?.find((x: CondominiumCondominium) => x.id === id)
      } else if (id.startsWith('tenancy')) {
        return this.allConnections.tenancies?.find((x: ObjecttenancyTenancy) => x.id === id)
      } else if (id.startsWith('obj')) {
        return this.allConnections.objects?.find((x: ObjectObject) => x.id === id)
      } else if (id.startsWith('building')) {
        return this.allConnections.buildings?.find((x: BuildingBuilding) => x.id === id)
      } else if (id.startsWith('prop')) {
        return this.allConnections.properties?.find((x: ObjectpropertyProperty) => x.id === id)
      } else if (id.startsWith('contact')) {
        return this.allConnections.contacts?.find((x: V2Person | Contactcontactv2Company) => x.id === id)
      } else if (id.startsWith('device')) {
        return this.allConnections.devices?.find((x: ObjectdeviceDevice) => x.id === id)
      } else if (id.startsWith('request')) {
        return this.allConnections.requests?.find((x: V2Request) => x.id === id)
      } else if (id.startsWith('room')) {
        return this.allConnections.rooms?.find((x: ObjectroomRoom) => x.id === id) || null
      } else if (id.startsWith('mortgage')) {
        return this.allConnections.mortgages?.find((x: MortgageMortgage) => x.id === id) || null
      } else if (id.startsWith('ins')) {
        return this.allConnections.insurances?.find((x: InsuranceInsurance) => x.id === id) || null
      }
    },
    getContactName(contactId: string): string | undefined {
      return this.listContacts.find((x: V2Person | Contactcontactv2Company) => x.id === contactId)?.name
    },
    redirectToDetailPage(item: any, type: string) {
      if (type === 'contact') {
        const contactId = item.id
        if (contactId !== null) {
          if (this.isOwnerModule) {
            return {
              name: 'OwnerContactDetailsView',
              params: { id: contactId }
            }
          } else if (this.isAssetModule) {
            return {
              name: 'AssetContactDetailsView',
              params: { id: contactId }
            }
          } else if (this.isAccountingModule) {
            return {
              name: 'AccountingContactDetailsView',
              params: { id: contactId }
            }
          } else if (this.isMarketingModule) {
            return {
              name: 'MarketingContactDetailsView',
              params: { id: contactId }
            }
          } else {
            return {
              name: 'AdminContactDetailsView',
              params: { id: contactId }
            }
          }
        }
      } else if (type === 'obj') {
        const buildingId = this.allConnections.buildings.find((y: BuildingBuilding) => y.objectIds.includes(item.id))?.id
        const objectId = item?.id
        const view = 'objects'
        if (this.isOwnerModule) {
          return {
            name: 'OwnerBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAdminModule) {
          return {
            name: 'AdminBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAssetModule) {
          return {
            name: 'AssetBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        } else if (this.isAccountingModule) {
          return {
            name: 'AccountingBuildingDetailsView',
            params: { id: buildingId },
            query: {
              view: view,
              elementSelected: objectId
            }
          }
        }
      } else if (type === 'building') {
        const buildingId = item.id.startsWith('building') ? item.id : item.id.startsWith('room') || item.id.startsWith('mortgage') ? item.referenceId : null
        if (buildingId) {
          if (this.isOwnerModule) {
            return {
              name: 'OwnerBuildingDetailsView',
              params: { id: buildingId },
              query: { view: 'building' }
            }
          } else if (this.isAssetModule) {
            return {
              name: 'AssetBuildingDetailsView',
              params: { id: buildingId },
              query: { view: 'building' }
            }
          } else if (this.isAccountingModule) {
            return {
              name: 'AccountingBuildingDetailsView',
              params: { id: buildingId },
              query: { view: 'building' }
            }
          } else if (this.isAdminModule) {
            return {
              name: 'AdminBuildingDetailsView',
              params: { id: buildingId },
              query: { view: 'building' }
            }
          }
        }
      } else if (type === 'prop') {
        const propertyId = item.id.startsWith('prop') ? item.id : item.id.startsWith('mortgage') || item.id.startsWith('ins') ? item.referenceId : null
        if (this.isOwnerModule) {
          return { name: 'OwnerPropertyDetailsView', params: { id: propertyId } }
        } else if (this.isAdminModule) {
          return { name: 'AdminPropertyDetailsView', params: { id: propertyId } }
        } else if (this.isAssetModule) {
          return { name: 'AssetPropertyDetailsView', params: { id: propertyId } }
        } else if (this.isAccountingModule) {
          return { name: 'AccountingPropertyDetailsView', params: { id: propertyId } }
        }
      }
      return ''
    },
    redirectToDeviceDetail(device: ObjectdeviceDevice) {
      const referenceId = device.referenceId
      const deviceId = device.id
      if (referenceId.startsWith('obj') || referenceId.startsWith('building')) {
        let id = null
        if (referenceId.startsWith('building')) {
          id = referenceId
        } else {
          const item = this.allConnections.buildings.filter((x: BuildingBuilding) => x?.objectIds.includes(referenceId))
          if (item.length > 0) {
            id = item[0].id
          }
        }
        if (id && deviceId) {
          if (this.isOwnerModule) {
            return { name: 'OwnerBuildingDetailsView', params: { id: id }, query: { view: 'devices', elementSelected: deviceId } }
          } else if (this.isAdminModule) {
            return { name: 'AdminBuildingDetailsView', params: { id: id }, query: { view: 'devices', elementSelected: deviceId } }
          } else if (this.isAssetModule) {
            return { name: 'AssetBuildingDetailsView', params: { id: id }, query: { view: 'devices', elementSelected: deviceId } }
          } else if (this.isAccountingModule) {
            return { name: 'AccountingBuildingDetailsView', params: { id: id }, query: { view: 'devices', elementSelected: deviceId } }
          }
        }
      } else {
        if (this.isOwnerModule) {
          return { name: 'OwnerPropertyDetailsView', params: { id: referenceId }, query: { view: 'devices', elementSelected: deviceId } }
        } else if (this.isAdminModule) {
          return { name: 'AdminPropertyDetailsView', params: { id: referenceId }, query: { view: 'devices', elementSelected: deviceId } }
        } else if (this.isAssetModule) {
          return { name: 'AssetPropertyDetailsView', params: { id: referenceId }, query: { view: 'devices', elementSelected: deviceId } }
        } else if (this.isAccountingModule) {
          return { name: 'AccountingPropertyDetailsView', params: { id: referenceId }, query: { view: 'devices', elementSelected: deviceId } }
        }
      }
      return ''
    },
    redirectToRequestDetail(objectId: string, requestId: string) {
      return {
        name: 'MarketingObjectDetailsView',
        params: { id: objectId },
        query: {
          view: 0,
          elementSelected: requestId
        }
      }
    }
  }
}

export { ticketConnections }
